<template>
    <register-layout v-on:submit="submit">
        <div class="tw-grid tw-grid-cols-1 tw-gap-6 tw-p-6">
            <div class="tw-text-xl tw-font-bold">{{$text.about_your_ideal_partner}}</div>

            <div>
                <textarea class="form-input" v-model="states.form.about_partner"></textarea>
                <div v-html="_.get(errors,'about_partner.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>

        </div>
    </register-layout>
</template>
<script>
    import store from './register-store'
    import RegisterLayout from './register-layout'

    export default {
        components: {RegisterLayout},
        data: v => ({
            states: store.states,
            errors: {},
        }),
        created() {
            this.store = store
        },
        methods: {
            submit() {
                store.states.loading = true
                axios.post('/validate-register', store.states.form)
                    .then(() => {
                        this.errors = {}
                    })
                    .catch(err => {
                        err.response.status === 422 && (this.errors = err.response.data.errors)
                    })
                    .finally(() => {
                        store.states.loading = false
                        if(store.hasNoErrors(this.errors,['about_me'])){
                            store.states.current_step++;
                        }
                    })
            },
        },
    }
</script>
